import { default as ScaleContext, type ScaleContextType } from './ScaleContext'
import { default as ReactResponsiveScale, type ReactResponsiveScaleProps } from './ReactResponsiveScale'

export default ReactResponsiveScale
export { ReactResponsiveScale, ScaleContext }
export type { ReactResponsiveScaleProps, ScaleContextType }
